import React from "react";


const Information = () => {
    return (
        <>
            <span className="info">
                <i className="fa-solid fa-location-dot"></i>
                <span> Đường Hàn Thuyên, khu phố 6 P, Thủ Đức, Thành phố Hồ Chí Minh</span>
            </span>
            <span className="info">
                <i className="fa-solid fa-mobile-screen-button"></i>
                <a href="tel:028 3725 2002">028 3725 2002</a>
            </span>
            <span className="info">
                <i className="fa-regular fa-envelope"></i>
                <a href="mailto:info@uit.edu.vn">info@uit.edu.vn</a>
            </span>
        </>
    )
}
export default Information